enum UserRole {
  OWNER = "owner",
  MWI_ADMIN = "mwi_admin",
  PRACTICE_ADMIN = "practice_admin",
}

export default UserRole;
